import api from "../client";

/* =======================================================
   LOGIN
======================================================= */

export const login = (
  payload
) =>
  api.post(
    "/auth/login",
    payload
  );

  /* =======================================================
   SIGNUP
======================================================= */

export const signup = (
  payload
) =>
  api.post(
    "/auth/signup",
    payload
  );

 /* =======================================================
   ME
======================================================= */

export const getMe = () =>
  api.get(
    "/auth/me"
  );

  /* =======================================================
   REFRESH
======================================================= */

export const refreshSession = (
  refreshToken
) =>
  api.post(
    "/auth/refresh",
    {
      refreshToken
    }
  );

  /* =======================================================
   LOGOUT
======================================================= */

export const logout = () =>
  api.post(
    "/auth/logout"
  );

  /* =======================================================
   LOGOUT ALL
======================================================= */

export const logoutAll = () =>
  api.post(
    "/auth/logout-all"
  );

  /* =======================================================
   SEND OTP
======================================================= */

export const sendOtp = (
  payload
) =>
  api.post(
    "/auth/send-otp",
    payload
  );

  /* =======================================================
   VERIFY OTP
======================================================= */

export const verifyOtp = (
  payload
) =>
  api.post(
    "/auth/verify-otp",
    payload
  );


  /* =======================================================
   SEND EMAIL VERIFICATION
======================================================= */

export const sendEmailVerification =
  () =>
    api.post(
      "/auth/send-email-verification"
    );

    /* =======================================================
   VERIFY EMAIL
======================================================= */

export const verifyEmail = (
  verificationId
) =>
  api.post(
    "/auth/verify-email",
    {
      verificationId
    }
  );

  /* =======================================================
   FORGOT PASSWORD
======================================================= */

export const forgotPassword = (
  email
) =>
  api.post(
    "/auth/forgot-password",
    {
      email
    }
  );


  /* =======================================================
   RESET PASSWORD
======================================================= */

export const resetPassword = ({
  verificationId,
  newPassword
}) =>
  api.post(
    "/auth/reset-password",
    {
      verificationId,
      newPassword
    }
  );